const API_URL = '/api/vehicle-data';

// Get all vehicle data
export const getAllVehicleData = async () => {
    try {
        const response = await fetch(API_URL);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error('Error fetching vehicle data:', error);
        throw error;
    }
};

// Get all brands
export const getBrands = async () => {
    try {
        const response = await fetch(`${API_URL}/brands`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error('Error fetching brands:', error);
        throw error;
    }
};

// Get models by brand
export const getModelsByBrand = async (brand) => {
    try {
        const response = await fetch(`${API_URL}/models/${brand}`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error(`Error fetching models for brand ${brand}:`, error);
        throw error;
    }
};

// Get all body types
export const getBodyTypes = async () => {
    try {
        const response = await fetch(`${API_URL}/types`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error('Error fetching body types:', error);
        throw error;
    }
};

// Import vehicle data (admin only)
export const importVehicleData = async (data) => {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/import`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error('Error importing vehicle data:', error);
        throw error;
    }
};